export async function getIpcRenderer() {
    // Проверяем доступность electron в текущем контексте
    if (typeof window === 'undefined' || !window.require) {
        console.warn('Not in Electron renderer process');
        return null;
    }

    try {
        const { ipcRenderer } = require('electron');
        return ipcRenderer;
    } catch (error) {
        console.error('Failed to load ipcRenderer:', error);
        return null;
    }
}